import { render, staticRenderFns } from "./BrandCenter.vue?vue&type=template&id=f6e41950&scoped=true"
import script from "./BrandCenter.vue?vue&type=script&lang=js"
export * from "./BrandCenter.vue?vue&type=script&lang=js"
import style0 from "./BrandCenter.vue?vue&type=style&index=0&id=f6e41950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e41950",
  null
  
)

export default component.exports